import ApiService from 'app/services/ApiService';

export const GET_NAMES_REQUEST = 'GET_NAMES_REQUEST';
export const GET_NAMES_SUCCESS = 'GET_NAMES_SUCCESS';
export const GET_NAMES_FAILURE = 'GET_NAMES_FAILURE';
export const GET_SUBDIRECTION_REQUEST = 'GET_SUBDIRECTION_REQUEST';
export const GET_SUBDIRECTION_SUCCESS = 'GET_SUBDIRECTION_SUCCESS';
export const GET_SUBDIRECTION_FAILURE = 'GET_SUBDIRECTION_FAILURE';
export const FETCH_TRAINING_REQUEST = 'FETCH_TRAINING_REQUEST';
export const FETCH_TRAINING_SUCCESS = 'FETCH_TRAINING_SUCCESS';
export const FETCH_TRAINING_FAILURE = 'FETCH_TRAINING_FAILURE';
export const EXPORT_TRAINING_REQUEST = 'EXPORT_TRAINING_REQUEST';
export const EXPORT_TRAINING_SUCCESS = 'EXPORT_TRAINING_SUCCESS';
export const EXPORT_TRAINING_FAILURE = 'EXPORT_TRAINING_FAILURE';
export const INSUPD_TRAINING_REQUEST = 'INSUPD_TRAINING_REQUEST';
export const INSUPD_TRAINING_SUCCESS = 'INSUPD_TRAINING_SUCCESS';
export const INSUPD_TRAINING_FAILURE = 'INSUPD_TRAINING_FAILURE';
export const DELETE_TRAINING_REQUEST = 'DELETE_TRAINING_REQUEST';
export const DELETE_TRAINING_SUCCESS = 'DELETE_TRAINING_SUCCESS';
export const DELETE_TRAINING_FAILURE = 'DELETE_TRAINING_FAILURE';
export const GET_EMPLOYEE_ADMIN_REQUEST = 'GET_EMPLOYEE_ADMIN_REQUEST';
export const GET_EMPLOYEE_ADMIN_SUCCESS = 'GET_EMPLOYEE_ADMIN_SUCCESS';
export const GET_EMPLOYEE_ADMIN_FAILURE = 'GET_EMPLOYEE_ADMIN_FAILURE';
export const GET_EMPLOYEE_ADMIN_ID_REQUEST = 'GET_EMPLOYEE_ADMIN_ID_REQUEST';
export const GET_EMPLOYEE_ADMIN_ID_SUCCESS = 'GET_EMPLOYEE_ADMIN_ID_SUCCESS';
export const GET_EMPLOYEE_ADMIN_ID_FAILURE = 'GET_EMPLOYEE_ADMIN_ID_FAILURE';
export const SAVE_ADMIN_REQUEST = 'SAVE_ADMIN_REQUEST';
export const SAVE_ADMIN_SUCCESS = 'SAVE_ADMIN_SUCCESS';
export const SAVE_ADMIN_FAILURE = 'SAVE_ADMIN_FAILURE';
export const GET_TRAINING_EMPLOYEE_REQUEST = 'GET_TRAINING_EMPLOYEE_REQUEST';
export const GET_TRAINING_EMPLOYEE_SUCCESS = 'GET_TRAINING_EMPLOYEE_SUCCESS';
export const GET_TRAINING_EMPLOYEE_FAILURE = 'GET_TRAINING_EMPLOYEE_FAILURE';
export const SAVE_ADMIN = 'SAVE_ADMIN';
export const SAVE_FILTER = 'SAVE_FILTER';
export const SAVE_PAGINATION = 'SAVE_PAGINATION';
export const CLEAR_REDUCER = 'CLEAR_REDUCER';

export const getNames = () => dispatch => {
    dispatch({ type: GET_NAMES_REQUEST });
    ApiService.getNamesTraining().then(
        response => {
            dispatch({
                type: GET_NAMES_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_NAMES_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getSubdirections = () => dispatch => {
    dispatch({ type: GET_SUBDIRECTION_REQUEST });
    ApiService.getSubdirectionsTraining().then(
        response => {
            dispatch({
                type: GET_SUBDIRECTION_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => dispatch({ type: GET_SUBDIRECTION_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message })
    )
}

export const fetchTraining = (param) => dispatch => {
    let objValidate = {}    

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }

    dispatch({ type: FETCH_TRAINING_REQUEST });
    ApiService.fetchTraining(objValidate).then(
        response => {
            dispatch({
                type: FETCH_TRAINING_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => dispatch({ type: FETCH_TRAINING_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message })
    )
}

export const exportXls = (param) => dispatch => {
    let objValidate = {}    

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }

    dispatch({ type: EXPORT_TRAINING_REQUEST });
    ApiService.exportTraining(objValidate).then(
        result => {
            const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            downloadFile(blob, "BandejaTipodeCapacitacion.xlsx");

            dispatch({ type: EXPORT_TRAINING_SUCCESS });
        }
    ).catch(
        (error) => dispatch({ type: EXPORT_TRAINING_FAILURE, payload: error.message })
    )
}

export const insUpdTraining = (data, callback) => dispatch => {
    dispatch({ type: INSUPD_TRAINING_REQUEST });
    ApiService.insUpdTraining(data).then(
        response => {
            dispatch({ 
                type: INSUPD_TRAINING_SUCCESS,
                payload: "El Tipo de Capacitación " + data.trainingName + " se guardo correctamente"
            });

            if (typeof callback === 'function') {
                callback();
            }
        }
    ).catch(
        (error) => dispatch({ type: INSUPD_TRAINING_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message })
    )
}

export const deleteTraining = (data, callback) => dispatch => {
    dispatch({ type: DELETE_TRAINING_REQUEST });
    ApiService.deleteTraining(data.idTraining).then(
        response => {
            
            dispatch({
                type: INSUPD_TRAINING_SUCCESS,
                payload: "Se eliminó correctamente el Tipo de Capacitación " + data.trainingName
            });

            if(typeof callback === 'function') {
                callback();
            }
        }
    ).catch(
        (error) => dispatch({ type: DELETE_TRAINING_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message })
    )
}

export const getEmployeeAdmin = () => dispatch => {
    dispatch({ type: GET_EMPLOYEE_ADMIN_REQUEST });
    ApiService.getEmployee().then(
        response => {
            dispatch({
                type: GET_EMPLOYEE_ADMIN_SUCCESS,
                payload: response.listData
            })
        }
    ).catch(
        (error) => dispatch({ type: GET_EMPLOYEE_ADMIN_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message })
    )
}

export const getEmployeeAdminId = (id, callback) => dispatch => {
    dispatch({ type: GET_EMPLOYEE_ADMIN_ID_REQUEST });
    ApiService.getEmployeeId(id).then(
        response => {
            dispatch({
                type: GET_EMPLOYEE_ADMIN_ID_SUCCESS,
                payload: response.listData
            })

            if(typeof callback === 'function'){
                callback(response.listData);
            }
        }
    ).catch(
        (error) => dispatch({ type: GET_EMPLOYEE_ADMIN_ID_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message })
    )
}

export const insUpdEmployeeTraining = (data, callback) => dispatch => {
    dispatch({ type: SAVE_ADMIN_REQUEST });
    ApiService.insUpdEmployeeTraining(data).then(
        response => {
            dispatch({ type: SAVE_ADMIN_SUCCESS });

            if(typeof callback === 'function') {
                callback();
            }
        }
    ).catch(
        (error) => dispatch({ type: SAVE_ADMIN_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message })
    )
}

export const getTrainingSelect = (employeeId) => dispatch => {
    dispatch({ type: GET_TRAINING_EMPLOYEE_REQUEST });
    ApiService.getTrainingEmployee(employeeId).then(
        response => {
            dispatch({
                type: GET_TRAINING_EMPLOYEE_SUCCESS,
                payload: response.listData
            })
        }
    ).catch(
        (error) => dispatch({ type: GET_TRAINING_EMPLOYEE_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message })
    )
}

export const clear = () => ({
    type: CLEAR_REDUCER
});

export const saveFilter = (filter) => ({
    type: SAVE_FILTER,
    payload: filter
});

export const savePagination = (pagination) => ({
    type: SAVE_PAGINATION,
    payload: pagination
});

export const saveAdmin = (data) => ({
    type: SAVE_ADMIN,
    payload: data
});

const downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
};